import ContentText from "./atoms/ContentText";
import HeadingText from "./atoms/HeadingText";
import MnLink from "./atoms/MnLink";
import ParaText from "./atoms/ParaText";
import { useTranslation } from "react-i18next";

function RootCause(props) {
  const { t } = useTranslation();
  const contentText1 = [
    t("homepage.rootcause.content.paragraph1"),
    t("homepage.rootcause.content.paragraph2"),
    t("homepage.rootcause.content.paragraph3"),
  ].join("\n\n");

  const contentText2 = [
    t("homepage.rootcause.content.paragraph4"),
    t("homepage.rootcause.content.paragraph5"),
    t("homepage.rootcause.content.paragraph6"),
  ].join("\n\n");

  return (
    <section className="bg-white py-12">
      <div className="max-w-6xl mx-auto px-4 ">
        <HeadingText variant="h2" classes="text-primary mb-8">
          {t("homepage.rootcause.heading")}
        </HeadingText>
        <ContentText>{contentText1}</ContentText>
        <ParaText classes="italic">{t("homepage.rootcause.paraText")}</ParaText>
        <ContentText>{contentText2}</ContentText>
        <MnLink
          to="/work-with-mn/individual-nutrition"
          name={t("homepage.rootcause.linkText")}
          classes="text-lg mb-0 mt-4"
        />
      </div>
    </section>
  );
}

export default RootCause;
